import Vue                        from "vue";
import { mapGetters }             from "vuex"
import { 
  MyAccount, 
  LoadingSpinner, 
  DnFunctionButton 
}                                 from "@/components";
import { UserSettingsService }    from "@/services";
import { sizeHelper }             from "@/components/mixins/sizeHelper";
import {constants}           from "@/const" 

export default Vue.extend({
  name: "UserSettings",
  components: {
    MyAccount,
    LoadingSpinner,
    DnFunctionButton
  },
  mixins:[sizeHelper],
  data: () => ({
    loadingUserSettings: true,
    userCollapsePartDescriptions: false,
    userpartSearchDefaultSort: "",
    sortByOptions: constants.SORT_BY_OPTIONS,
    userGridViewDefault: false,
    userShowSideCart: false,
    savingUserSettings: false,
    userTmsCompactViewDefault: false,
  }),
  computed:{
    ...mapGetters([
      "user",
      "getContentItem",
      "userSettings",
      "collapseAllPartDescriptions",
      "partSearchDefaultSort",
      "showSideCart",
      "gridViewDefault",
      "tmsCompactViewDefault",
    ]),
  },
  mounted() {
    this.getUserSettings();
  },
  methods:{
    async getUserSettings(){
      this.loadingUserSettings = true;
      
      // This handles a refresh from the user settings page
      if (this.userSettings === undefined || this.userSettings.length === 0){
        await UserSettingsService.GetUserSettings(this.user.UserId)
          .then( userSettings => {
            this.$store.commit("SET_USER_SETTINGS", userSettings)
          });
      }
      this.userCollapsePartDescriptions = await this.collapseAllPartDescriptions;
      this.userpartSearchDefaultSort = await this.partSearchDefaultSort;
      this.userShowSideCart = await this.showSideCart;
      this.userGridViewDefault = await this.gridViewDefault;
      this.userTmsCompactViewDefault = await this.tmsCompactViewDefault;
      this.loadingUserSettings = false;
    },
    async saveUserSettings(){    
      this.savingUserSettings = true;
      this.$store.commit("SET_COLLAPSE_ALL_PART_DESCRIPTIONS", this.collapseAllPartDescriptions.SettingValue);
      this.$store.commit("SET_PART_SEARCH_DEFAULT_SORT", this.partSearchDefaultSort.SettingValue);
      this.$store.commit("SET_GRID_VIEW_DEFAULT", this.gridViewDefault.SettingValue);
      this.$store.commit("SET_SHOW_SIDE_CART", this.userShowSideCart.SettingValue);
      this.$store.commit("SET_TMS_COMPACT_VIEW", this.tmsCompactViewDefault.SettingValue);

      let result = false;
      try{
        result = await UserSettingsService.SaveUserSettings(this.userSettings);
        if( result === true){
          this.$store.commit("SET_USER_SETTINGS", this.userSettings);
          this.$store.commit("pushTimedMessage", {
            header: "User settings saved successfully.",
            IsError: false,
            seconds: 5,
          });
        }else{
          this.$store.commit("pushTimedMessage", {
            header: "There was a problem saving user settings.",
            IsError: true,
            seconds: 5,
          });
        }
      }catch{
        this.$store.commit("pushTimedMessage", {
          header: "There was a problem saving user settings.",
          IsError: true,
          seconds: 5,
        });
      }finally{
        this.savingUserSettings = false;
      }  
    },
  }
});